import { coursesTags } from "../context/tags";
import { postUserToBC } from "../services/signUp";
import { formatDate } from "./courses";

export const applyBootcamp = async (courseData, email) => {
  try {
    const { cohortLabel, startDate, endDate, priceUSD } = courseData;
    const source = localStorage.getItem("utm_source");

    const infoToSend = {
      cohort: cohortLabel,
      course:
        cohortLabel.split("-")[0] === coursesTags.BC_JAVASCRIPT
          ? "Bootcamp JS"
          : "Bootcamp SF",
      date: `${formatDate(startDate)} al ${formatDate(endDate)}`,
      amount: priceUSD,
      currency: "USD",
      email,
      source,
    };

    await postUserToBC(infoToSend);
  } catch (err) {
    throw err;
  }
};
